import { Routes, Route } from "react-router-dom";
import MerchantList from "./MerchantList";
import MerchantForm from "./MerchantForm";

export default function Merchant(){
  return (
    <div>
      <h2>Merchants</h2>
      <Routes>
        <Route path="/" element={<MerchantList />} />
        <Route path="new" element={<MerchantForm />} />
        <Route path="edit/:id" element={<MerchantForm />} />
      </Routes>
    </div>
  );
}
